import { render, staticRenderFns } from "./AttachmentModal.vue?vue&type=template&id=861e7b06&scoped=true"
import script from "./AttachmentModal.vue?vue&type=script&lang=js"
export * from "./AttachmentModal.vue?vue&type=script&lang=js"
import style0 from "./AttachmentModal.vue?vue&type=style&index=0&id=861e7b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861e7b06",
  null
  
)

export default component.exports